export enum WorkSchedulePositionTypeFilterOptions {
    Working = 0,
    Reachable = 1,
}
